module.exports = "/_next/static/images/app_store_badge-6b0b40b18106c1753ca8333a8972df63.svg";